import React, { useState, useEffect, useRef } from "react";
import config from "../../Config";
import axios from "axios";
import moment from "moment";
import { Link, NavLink, useParams } from "react-router-dom";
import { Cropper } from "react-cropper";
import { Form } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Modal from 'react-bootstrap/Modal';
import { Average, Excellent, Good, Happy, Poor } from "../UserControls/Icons";
import SupportTopMenu from "./SupportTopMenu";

function TicketsListing(props) {

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [replies, setReplies] = useState([]);
    const [ticketType, setTicketType] = useState(null);
    const [ticket, setTicket] = useState({});
    const [assignees, setAssignees] = useState({ users: [], staff: [] });
    const [assignValue, setAssignValue] = useState("");
    const [assignLoading, setAssignLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);

    const [imageSelected, setImageSelected] = useState(false);
    const [AttachmentString, setAttachmentString] = useState("");

    const [image, setImage] = useState('');
    const [cropper, setCropper] = useState();
    const [imageCropped, setImageCropped] = useState(false);
    const [replySaved, setReplySaved] = useState(false);
    const [ClosedByAdmin, SetClosedByAdmin] = useState("");
    const [ClosedByUser, SetClosedByUser] = useState("");

    const [loadingTickets, setLoadingTickets] = useState(false);
    const [attachmentImg, setAttachmentImg] = useState(null);
    const [tick, settick] = useState(false);

    const [description, setdescription] = useState("");
    // const status = useRef(null);

    // modals
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    }

    const [showModalAttachment, setShowModalAttachment] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const handleShowModalAttachment = (item) => {
        setAttachmentImg(item);
        setShowModalAttachment(true);
    }

    const handleCloseModalAttachment = () => {
        setShowModalAttachment(false);

    }

    const handleCloseModal = () => {
        setShowModal(false);
        setImageSelected(false);
        setLoading(false);
    }
    const handleShowModal = () => {
        setShowModal(true);
    }

    let params = useParams();

    useEffect(() => {
        setReplySaved(false);
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            ID: params.id

        };

        var api_config = {
            method: 'post',
            url: config.base_url + 'Support/GetTicketByIDAdmin',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(api_config)
            .then(function (response) {
                //console.log(response.data);
                setReplies(response.data.ListofReplies);
                setTicket(response.data);
                if (response.data.AssignToID && response.data.AssignedToType) {
                    setAssignValue(
                        response.data.AssignedToType + ":" + response.data.AssignToID
                    );
                }
                SetClosedByAdmin(response.data.ClosedByAdmin);
                SetClosedByUser(response.data.ClosedByUser);
                //console.log(response.data.ListofReplies);
                const element = document.getElementById("chat-thread");
                if (element) {
                    element.scrollTop = element.scrollHeight;
                }
            })
            .catch(function (error) {
                //console.log(error);
            });

    }, [replySaved]); // Dependency array

    useEffect(() => {
        axios({
            method: "post",
            url: config.base_url + "Support/GetSupportAssignees",
            headers: { "Content-Type": "application/json" },
            data: { AccessKey, UserID, SchoolID: 1 },
        })
            .then((res) => {
                if (res.data.status_code === 1) {
                    setAssignees({
                        users: res.data.ListofUsers || [],
                        staff: res.data.ListofStaff || [],
                    });
                }
            })
            .catch(() => { });
    }, [AccessKey, UserID]);

    const handleAssignTicket = () => {
        if (!assignValue) return;
        const parts = assignValue.split(":");
        if (parts.length !== 2) return;
        setAssignLoading(true);
        axios({
            method: "post",
            url: config.base_url + "Support/AssignSupportTicket",
            headers: { "Content-Type": "application/json" },
            data: {
                UserID,
                AccessKey,
                ID: params.id,
                AssignedToType: parts[0],
                AssignToID: parseInt(parts[1], 10),
            },
        })
            .then((res) => {
                if (res.data.status_code === 1) {
                    toast.success(res.data.status_message);
                    setTicket((t) => ({
                        ...t,
                        AssignedToName: res.data.AssignedToName,
                        AssignToID: res.data.AssignToID,
                        AssignedToType: res.data.AssignedToType,
                    }));
                } else {
                    toast.error(res.data.status_message || "Could not assign ticket.");
                }
                setAssignLoading(false);
            })
            .catch(() => {
                setAssignLoading(false);
                toast.error("Network error.");
            });
    };

    const onChange = (e) => {
        e.preventDefault();
        setImageSelected(true);
        let files;
        if (e.dataTransfer) {
            files = e.dataTransfer.files;
        } else if (e.target) {
            files = e.target.files;
        }
        const reader = new FileReader();
        reader.onload = () => {
            setImage(reader.result);
        };
        reader.readAsDataURL(files[0]);
    };

    const getCropData = () => {

        if (typeof cropper !== "undefined") {

            var cropData1 = cropper.getCroppedCanvas().toDataURL();
            setImageCropped(true);
            var cleanerBase64 = cropData1.substring(22);
            setAttachmentString(cleanerBase64);
            handleCloseModal();
            setAttachmentShow(false);
            settick(true);
        }
    };


    const SubmitReply = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            setLoadingTickets(true);
            const data = {
                UserID: UserID,
                AccessKey: AccessKey,
                ID: params.id,
                Description: description,
                Status: "",
                FileAttached: AttachmentString,
            };

            var api_config = {
                method: 'post',
                url: config.base_url + 'Support/AdminReplyTicket',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios(api_config)
                .then(function (response) {
                    //console.log(response.data);
                    if (response.data.status_code == 1) {
                        setReplySaved(true);
                        setdescription("");
                        setAttachmentString("");
                        //console.log(response.data)
                        // status.current.value = null;
                        setValidated(false);
                        setLoadingTickets(false);
                        settick(false);
                        // Scroll to the bottom after receiving a message

                        const chatThread = document.getElementById("chat-thread");
                        if (chatThread) {
                            chatThread.scrollTop = chatThread.scrollHeight;
                        }
                    }
                    else {
                        toast.error(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        setLoadingTickets(false);
                    }


                })
                .catch(function (error) {
                    setLoading(false);
                    toast.error('Network Error..', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                });
            setValidated(true);
        }
    };
    const renderReplies = () => {
        if (!replies) return null;

        return replies.map((item, index) => {
            const isUser = item.Member_ID > 0;

            const fullName = isUser
                ? item.Member_Name
                : item.Admin_Name || "Support";

            const firstLetter = fullName?.charAt(0)?.toUpperCase();

            return (
                <div
                    key={index}
                    className={`chat-item ${isUser ? "student" : "admin"}`}
                >
                    {/* AVATAR */}
                    <div
                        className={`chat-avatar ${isUser ? "student-avatar" : "admin-avatar"
                            }`}
                        title={fullName}
                    >
                        {firstLetter}
                    </div>

                    {/* MESSAGE */}
                    <div className="chat-text">
                        <div
                            className={`message-bubble ${isUser ? "student-bubble" : "admin-bubble"
                                }`}
                        >
                            <div
                                className="message-content"
                                dangerouslySetInnerHTML={{
                                    __html: item.Description,
                                }}
                            />

                            <span className="bubble-date">
                                {moment(item.Created_Date).format(
                                    "DD MMM YYYY • hh:mm A"
                                )}
                            </span>
                        </div>

                        {/* ATTACHMENT */}
                        {item.FileAttached && (
                            <div className="attachment-wrap">
                                <button
                                    type="button"
                                    className="button-view-attachment"
                                    onClick={() =>
                                        handleShowModalAttachment(item.FileAttached)
                                    }
                                >
                                    <i className="ri-attachment-line"></i>
                                    View Attachment
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            );
        });
    };

    const [feedback, setfeedback] = useState("");
    const [comment, setcomment] = useState("");

    const handleFeedBack = (event) => {
        if (event.target.checked) {
            setfeedback(event.target.value);

        }
    };

    const sendfeedback = () => {
        setShow(false)
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            ID: params.id,
            Feedback: feedback,
            Comments: comment

        };
        //console.log("feedback", data)
        var api_config = {
            method: 'post',
            url: config.base_url + 'Support/CloseTicketAdmin',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };
        axios(api_config)
            .then(function (response) {
                toast.success(response.data.status_message, {
                    position: toast.POSITION.TOP_RIGHT
                });
                window.location.reload();
            })
            .catch(function (error) {
                //console.log(error);
            });
    }
    const TicketNotClosed = () => {
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            ID: params.id,
        };
        var api_config = {
            method: 'post',
            url: config.base_url + 'Support/TicketNotClosed',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };


        axios(api_config)
            .then(function (response) {
                toast.success(response.data.status_message, {
                    position: toast.POSITION.TOP_RIGHT
                });
                window.location.reload();
            })
            .catch(function (error) {
                //console.log(error);
            });
    }
    const rendercloseadmin = () => {
        if (ClosedByUser == true && ClosedByAdmin == false) {
            return (
                <>
                    <div className="col-12">
                        <div className="sms-recode mb-3">
                            <p>User requested to close this ticket. Confirm?</p>
                        </div>
                        <div className="d-flex justify-content-center gap-3 mb-3">
                            <button type="button" className="button button-primary" onClick={handleShow}>
                                <span><i className="ri-checkbox-circle-line"></i> Yes</span>
                            </button>
                            <button type="button" className="button button-primary" onClick={TicketNotClosed}>
                                <span><i className="ri-close-circle-line"></i> No</span>
                            </button>
                        </div>
                    </div>
                </>
            )
        }
        else if (ClosedByAdmin == true && ClosedByUser == false) {
            return (
                <>
                    <div className="col-12">
                        <div className="sms-recode mb-3">
                            <p>User requested to close this ticket. Confirm?</p>
                        </div>
                        <div className="d-flex justify-content-center gap-3 mb-3">
                            <button type="button" className="button button-primary" onClick={handleShow}>
                                <span><i className="ri-checkbox-circle-line"></i> Yes</span>
                            </button>
                            <button type="button" className="button button-primary" onClick={TicketNotClosed}>
                                <span><i className="ri-close-circle-line"></i> No</span>
                            </button>
                        </div>
                    </div>
                </>
            )
        }
        else if (ClosedByAdmin == false && ClosedByUser == false) {
            return (
                <>
                </>
            )
        }
        else if (ClosedByAdmin == true && ClosedByUser == true) {
            return (
                <>
                </>
            )
        }
    }

    const [Attachmentshow, setAttachmentShow] = useState(false);
    const handleAttachmentClose = () => setAttachmentShow(false);

    const handleAttachmentshow = () => {
        setAttachmentShow(true);
    }
    const renderreply = () => {
        const canReply =
            (ClosedByUser === true && ClosedByAdmin === false) ||
            (ClosedByAdmin === false && ClosedByUser === false);

        if (!canReply) return null;

        return (
            <div className="reply-box">
                <textarea
                    rows={1}
                    value={description}
                    className="send-input"
                    onChange={(e) => setdescription(e.target.value)}
                    placeholder="Type your reply..."
                />

                <button
                    type="submit"
                    disabled={loadingTickets || !description.trim()}
                    className="reply-button"
                >
                    Send
                    <i className="ri-send-plane-2-fill"></i>
                </button>
            </div>
        );
    };
    const renderCloseButton = () => {
        if (ClosedByUser == true && ClosedByAdmin == false) {
            return (
                <>
                    <div className="my-3 text-md-start text-center">
                        <button
                            onClick={handleShow}
                            className="button button-primary">Close Ticket</button>
                    </div>
                </>
            )
        }
        else if (ClosedByAdmin == true && ClosedByUser == false) {
            return (
                <>
                </>
            )
        }
        else if (ClosedByAdmin == false && ClosedByUser == false) {
            return (
                <>
                    <div className="my-3 text-md-start text-center">
                        <button
                            onClick={handleShow}
                            className="button button-primary">Close Ticket</button>
                    </div>
                </>
            )
        }
        else if (ClosedByAdmin == true && ClosedByUser == true) {
            return (
                <>
                </>
            )
        }
    }


    return (
        <>
            <ToastContainer />
            <Modal className="modal-theme modal-small p-0" show={show} onHide={handleClose}>
                <div className="modal-header">
                    <div className="modal-title h2">FeedBack</div>

                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleClose}></button>
                </div>
                <Modal.Body>
                    <ul className={`feedback_list`}>
                        <li>
                            <label
                                htmlFor="FeedBackPoor"
                                className={` ${feedback === 'Poor' ? 'active' : ''}`}
                            >
                                <Poor />
                                <span>Poor</span>
                                <input
                                    className=""
                                    id="FeedBackPoor"
                                    className="feedback"
                                    type="radio"
                                    value="Poor"
                                    onChange={handleFeedBack}
                                    checked={feedback === 'Poor'}
                                />
                            </label>
                        </li>
                        <li>
                            <label
                                htmlFor="FeedBackAverage"
                                className={` ${feedback === 'Average' ? 'active' : ''}`}
                            >
                                <Average />
                                <span>Average</span>
                                <input
                                    className=""
                                    id="FeedBackAverage"
                                    className="feedback"
                                    type="radio"
                                    value="Average"
                                    onChange={handleFeedBack}
                                    checked={feedback === 'Average'}
                                />
                            </label>
                        </li>
                        <li>
                            <label
                                htmlFor="FeedBackGood"
                                className={` ${feedback === 'Good' ? 'active' : ''}`}
                            >
                                <Good />
                                <span>Good</span>
                                <input
                                    className=""
                                    id="FeedBackGood"
                                    className="feedback"
                                    type="radio"
                                    value="Good"
                                    onChange={handleFeedBack}
                                    checked={feedback === 'Good'}
                                />
                            </label>
                        </li>
                        <li>
                            <label
                                htmlFor="FeedBackHappy"
                                className={` ${feedback === 'Happy' ? 'active' : ''}`}
                            >
                                <Happy />
                                <span>Happy</span>
                                <input
                                    className=""
                                    id="FeedBackHappy"
                                    className="feedback"
                                    type="radio"
                                    value="Happy"
                                    onChange={handleFeedBack}
                                    checked={feedback === 'Happy'}
                                />
                            </label>
                        </li>
                        <li>
                            <label
                                htmlFor="FeedBackExcellent"
                                className={` ${feedback === 'Excellent' ? 'active' : ''}`}
                            >
                                <Excellent />
                                <span>Excellent</span>
                                <input
                                    className=""
                                    id="FeedBackExcellent"
                                    className="feedback"
                                    type="radio"
                                    value="Excellent"
                                    onChange={handleFeedBack}
                                    checked={feedback === 'Excellent'}
                                />
                            </label>
                        </li>

                        {/* <li onClick={handleClick1} className={`${isActive1 ? "active" : ""}`}>
                            <Poor />
                            <p>Poor</p>
                        </li>
                        <li onClick={handleClick2} className={`${isActive2 ? "active" : ""}`}>
                            <Average />
                            <p>Average</p>
                        </li>
                        <li onClick={handleClick3} className={`${isActive3 ? "active" : ""}`}>
                            <Good />
                            <p>Good</p>
                        </li>
                        <li onClick={handleClick4} className={`${isActive4 ? "active" : ""}`}>
                            <Happy />
                            <p>Happy</p>
                        </li>
                        <li onClick={handleClick5} className={`${isActive5 ? "active" : ""}`}>
                            <Excellent />
                            <p>Excellent</p>
                        </li> */}
                        <li>
                            <div className="form_default w-100">
                                <div className="form-group">
                                    <div className="inputwrap">
                                        <textarea type="text" style={{ boxShadow: "none" }} onChange={(e) => setcomment(e.target.value)} className="form-control" placeholder="Comments" required="" value={comment} />
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <button onClick={sendfeedback}
                                disabled={feedback.length === 0 || comment.length === 0}
                                className="button button-primary w-100"><span>Submit</span></button>
                        </li>
                    </ul>
                </Modal.Body>
            </Modal>
            <Modal
                show={showModalAttachment}
                onHide={handleCloseModalAttachment}
            >
                <Modal.Header closeButton>
                    <Modal.Title>View Attachment</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <img
                        src={config.root + `SupportTicket/SupportFiles/${attachmentImg}`}
                        className="img-fluid"
                        alt="Attachment"
                    />
                </Modal.Body>
            </Modal>
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Upload Attachment</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="upload-photo-wrap">
                        {
                            imageSelected ?
                                <Cropper
                                    zoomTo={0.5}
                                    preview=".img-preview"
                                    src={image}
                                    dragMode="move"
                                    viewMode={2}
                                    minCropBoxHeight={10}
                                    minCropBoxWidth={10}
                                    background={false}
                                    responsive={true}
                                    autoCropArea={1}
                                    checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                                    onInitialized={(instance) => {
                                        setCropper(instance);
                                    }}
                                    guides={true}
                                />
                                :
                                <div className="choose-photo">
                                    <label htmlFor="ChoosePhoto">
                                        <i className="ri-chat-poll-line">upload</i>
                                        <span>Browse Photo</span>
                                        <input id="ChoosePhoto" accept="image/jpeg,image/png" type="file" onChange={onChange} />
                                    </label>

                                </div>

                        }
                    </div>
                    <div className="modal-footer justify-content-center">
                        <button className="button button-outline-primary me-2" onClick={handleCloseModal}>Close</button>
                        <button className="button button-primary" onClick={getCropData}>Save Photo</button>
                    </div>
                </Modal.Body>
            </Modal>
            <SupportTopMenu />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"> <Link to="/support/raise-ticket">Support</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Tickets Details</li>
                                </ol>
                            </nav>
                            <div className="page-title">Tickets Details ({ticket.TicketType})</div>
                            {ticket.FullName ? (
                                <p className="small text-muted mb-0">
                                    From: {ticket.FullName}
                                    {ticket.MemberType ? ` (${ticket.MemberType})` : ""}
                                    {ticket.ContactNo ? ` · ${ticket.ContactNo}` : ""}
                                </p>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex flex-wrap gap-2 align-items-end justify-content-md-end">
                                <div>
                                    <label className="form-label small mb-1">Assigned to</label>
                                    <select
                                        className="form-select form-select-sm"
                                        value={assignValue}
                                        onChange={(e) => setAssignValue(e.target.value)}
                                        style={{ minWidth: "220px" }}
                                    >
                                        <option value="">
                                            {ticket.AssignedToName || "Select assignee"}
                                        </option>
                                        <optgroup label="Users">
                                            {assignees.users.map((u) => (
                                                <option key={`U-${u.AssignToID}`} value={`User:${u.AssignToID}`}>
                                                    {u.DisplayName}
                                                </option>
                                            ))}
                                        </optgroup>
                                        <optgroup label="Staff">
                                            {assignees.staff.map((s) => (
                                                <option key={`S-${s.AssignToID}`} value={`Staff:${s.AssignToID}`}>
                                                    {s.DisplayName}
                                                </option>
                                            ))}
                                        </optgroup>
                                    </select>
                                </div>
                                <button
                                    type="button"
                                    className="button button-primary"
                                    disabled={assignLoading || !assignValue}
                                    onClick={handleAssignTicket}
                                >
                                    {assignLoading ? "Assigning..." : "Assign"}
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="container">
                <div className="ticket-card card mb-3">
                    <div className="card-body ticket-card-body">

                        {/* TOP INFO ROW */}
                        <div className="ticket-meta">
                            <div className="meta-item">
                                <i className="ri-coupon-line"></i>
                                <span>Ticket #{ticket.TicketID}</span>
                            </div>

                            <div className="meta-item">
                                <i className="ri-calendar-2-fill"></i>
                                <span>
                                    {ticket.Dated
                                        ? moment(ticket.Dated).format("DD MMM YYYY • hh:mm A")
                                        : "-"}
                                </span>
                            </div>

                            <div className="meta-item">
                                <i className="ri-chat-poll-line"></i>
                                <span>{ticket.NoofReplies} messages</span>
                            </div>

                            <div className={`ticket-status ${ticket.Status?.toLowerCase()}`}>
                                {ticket.Status}
                            </div>
                            {ticket.AssignedToName ? (
                                <div className="ticket-status open"><i className="ri-user-line"></i> {ticket.AssignedToName}</div>
                            ) : null}
                        </div>

                        {/* SUBJECT */}
                        {ticket.Subject && (
                            <div className="ticket-subject">
                                {ticket.Subject}
                            </div>
                        )}

                        {/* ATTACHMENT */}
                        {ticket.FileAttached && (
                            <button
                                type="button"
                                className="attachment-btn"
                                onClick={() =>
                                    handleShowModalAttachment(ticket.FileAttached)
                                }
                            >
                                <i className="ri-attachment-line"></i>
                                View original attachment
                            </button>
                        )}

                    </div>
                </div>
                <div className="card chat-style">
                    <div id="chat-thread" className="card-height scrollbar">
                        <div className="row">
                            {renderReplies()}
                            {rendercloseadmin()}
                        </div>
                    </div>
                    <Form noValidate validated={validated} onSubmit={SubmitReply}>
                        {renderreply()}
                    </Form>
                </div>
                {renderCloseButton()}
            </div>
        </>
    );
}

export default TicketsListing;